/**
 * watchEverything.tsx
 */
import Focus from '@shared/types/enums/focus';
import Rail from '@shared/classes/rail';
import MainTemplate from '@components/templates/main/ui/main';
import watchEverythingObservable from '@shared/api/watchEverything/observable';
import useComplete from '@shared/components/utils/hooks/useComplete';
import { Observer, Subscription } from 'rxjs';
import { selectCurrentParams } from '@shared/store/slices/router.slice';
import { setFocus } from '@shared/store/slices/focus.slice';
import { useAppDispatch, useAppSelector } from '@shared/store/hooks';
import { useState, useEffect } from 'react';

/**
 * Displays the watch everything page with the rails.
 */
export default function WatchEverything() {
  // Dispatch
  const dispatch = useAppDispatch();

  // Selectors
  const currentParams = useAppSelector(selectCurrentParams);

  // State
  const [complete, setComplete] = useComplete();
  const [rails, setRails] = useState<Rail[]>([]);

  // Effect hooks

  /**
   * Effect hook that retrieves the watch everything data.
   */
  useEffect(() => {
    let subscription: Subscription | null = null;
    if (currentParams?.channelName && !complete) {
      const observer: Observer<Rail[]> = {
        next: (val) => {
          setRails(val);
        },
        error: () => {
          console.error('Error recovering content');
        },
        complete: () => {
          setComplete(true);
          setComplete(true);
          dispatch(
            setFocus([
              Focus.RAILS_LIST,
              parseInt(`${Focus.RAILS_SUB_LIST}${0}`),
            ])
          );
          return null;
        },
      };
      subscription = watchEverythingObservable(
        (currentParams as { channelName: string })?.channelName
      ).subscribe(observer as Partial<Observer<unknown>>);
    }

    return () => {
      subscription?.unsubscribe();
    };
  }, [currentParams, complete]);

  // Render
  return <MainTemplate flags={{ complete }} rails={rails} />;
}
